// WARNING ****************************************************************************
// This file is automatically generated. We recommend that you do not edit it manually.
// ************************************************************************************

// This file imports Olympe and project and dependencies bricks source code, so that Webpack can bundle everything together.

// Import Olympe runtime or DRAW
import 'olympe';
import '@olympeio/core';
import '@olympeio-extensions/azure';
import '@olympeio-extensions/chartjs';
import '@olympeio-extensions/commons';
import '@olympeio-extensions/file-format-support';
import '@olympeio-extensions/google';
import '@olympeio-extensions/mail';
import '@olympeio-extensions/mapbox';
import '@olympeio-extensions/media-device';
import '@olympeio-extensions/monitoring';
import '@olympeio-extensions/qrcode-zxing';

import '@orionis/commons';
import '@orionis/bexio';
import '@orionis/infomaniak';
import '@orionis/sap-b1';


import './bricks/web/aptissen/DGJournalEntry.js'; import './bricks/web/aptissen/MapToObjects.js'; import './bricks/web/Binance/TransformOrdersToBalanceLines.js'; import './bricks/web/Binance/TransformOrdersToMarkLines.js'; import './bricks/web/localOpenAI/DoModelExist.js'; import './bricks/web/localOpenAI/LoadSTTModel.js'; import './bricks/web/localOpenAI/StreamAudioToText.js'; import './bricks/web/localOpenAI/STTLocalWhisper.js';
import './bricks/web/Bilan/BilanCategDisplay.jsx'; import './bricks/web/Binance/AnalysisHomeSwitch.jsx'; import './bricks/web/Binance/AnalysisStrategyDetail.jsx'; import './bricks/web/Binance/CandleStickChart.jsx'; import './bricks/web/Binance/HomePageContent.jsx'; import './bricks/web/Binance/TermsAndconditions.jsx'; import './bricks/web/OrionisUI/Calendar.jsx'; import './bricks/web/OrionisUI/DarkResponsiveLayout.jsx'; import './bricks/web/OrionisUI/Drawer.jsx'; import './bricks/web/OrionisUI/LightResponsiveLayout.jsx'; import './bricks/web/Qualiteeth/Dentition.jsx'; import './bricks/web/Sanctuary/Landing.jsx'; import './bricks/web/Sanctuary/NotificationList.jsx'; import './bricks/web/Team22/Team22Layout.jsx';
import './bricks/common/expenses/PriceSum.js';